export const extractReportId = (link) => {
  // Add null/undefined check
  if (!link || typeof link !== 'string') {
    return null; // or return a default value
  }

  // Define a regular expression pattern to match the report ID
  const regexPattern = /reports\/([a-f0-9-]+)\/ReportSection/;

  // Use the regular expression to match the report ID
  const match = link.match(regexPattern);

  // If a match is found, return the report ID
  if (match && match[1]) {
    // console.log('link', link);
    // console.log('link', match[1]);
    return match[1];
  }

  // Return null or an appropriate value if no match is found
  return null;
};
